import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { closeInvoiceFormDialog } from '../../../../actions'
import mobileView from '../../../../utils/mobile.utils'

const InvoiceSent = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const invoiceHasBeenSentImage = '../../../images/lasku.png'

  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '-20px'
        }}
      >
        <h3
          style={{
            fontSize: mobileView ? '22px' : '',
            fontWeight: '600',
            color: '#000',
            textAlign: 'center',
            textTransform: 'none'
          }}
        >
          {t('invoice.invoiceSent')}
        </h3>
        <img
          style={{
            width: !mobileView ? '300px' : '200px',
            minHeight: '200px',
            display: 'block',
            margin: '20px auto'
          }}
          src={invoiceHasBeenSentImage}
          alt="Your invoice has been sent"
        />
      </div>

      <Button
        variant="contained"
        className="pull-right"
        type="submit"
        onClick={() => dispatch(closeInvoiceFormDialog())}
        style={{
          alignSelf: 'flex-end'
        }}
      >
        {t('invoice.finished')}
      </Button>
    </div>
  )
}

export default InvoiceSent
